import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '@shared/models';
import { InitActions } from '@shared/state/actions';
import { SpinnerCoverContainerComponent } from './features/spinner/components';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterOutlet, SpinnerCoverContainerComponent],
})
export class AppComponent {
  constructor(private store$: Store<IAppState>) {
    this.markAppInit();
  }

  private markAppInit(): void {
    this.store$.dispatch(InitActions.pageInitialized());
  }
}
